import { render, staticRenderFns } from "./Product4.vue?vue&type=template&id=f2ddc7ba&"
import script from "./Product4.vue?vue&type=script&lang=js&"
export * from "./Product4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports